import type { AeropayUser } from '@iheartjane/data-access';
import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type { ActionResult } from '@jane/bloom/types/actions/remixAction';

export function useAeropayUser() {
  const basename = useBloomBasename();
  const fetcher = useFetcher<ActionResult<AeropayUser | null>>();

  const fetchAeropayUser = useCallback(() => {
    fetcher.load(`${basename}api/aeropay-user`);
  }, [basename, fetcher]);

  return {
    data: fetcher.data,
    fetchAeropayUser,
    state: fetcher.state,
  };
}
